import React, { Component } from 'react';
import './AvailabilityIndicator.css';

const availabilityClasses = {
  0: 'offline',
  1: 'available',
  2: 'away',
  3: 'busy'
};

class AvailabilityIndicator extends Component {
  render() {
    const { availability } = this.props;

    let classNames = ['AvailabilityIndicator'];
    if (availabilityClasses[availability] !== undefined) {
      classNames.push(`AvailabilityIndicator--${availabilityClasses[availability]}`)
    }

    return (
      <span className={classNames.join(' ')}></span>
    );
  }
}

export default AvailabilityIndicator;



// WEBPACK FOOTER //
// ./src/components/AvailabilityIndicator.js